module.exports = __webpack_public_path__ + "static_pc/img/logo.344fa7e.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/logo.png
// module id = bPD/
// module chunks = 187